const BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || ''
const DEV_API_PORT_1 = process.env.NEXT_PUBLIC_DEV_API_ENDPOINT_PORT_1 || BASE_URL

export default {
  meEndpoint: `${DEV_API_PORT_1}/v1/api/c/auth/user`,
  loginEndpoint: `${DEV_API_PORT_1}/v1/api/c/auth/login`,
  clientLoginEndpoint: `${DEV_API_PORT_1}/v1/api/c/auth/login/client-selection`,
  updateUserClientFavouriteStatusEndpoint: `${DEV_API_PORT_1}/v1/api/c/auth/user-client/favourite`,
  // Refresh trades the HttpOnly refresh_token cookie (set by /login/client-selection)
  // for a new access token; logout revokes it server-side and clears the cookie.
  refreshEndpoint: `${DEV_API_PORT_1}/v1/api/c/auth/refresh`,
  logoutEndpoint: `${DEV_API_PORT_1}/v1/api/c/auth/logout`,
  storageTokenKeyName: 'accessToken',
  onTokenExpiration: 'refreshToken' // logout | refreshToken
}
